import { GetBillingCalculationRes, GetSubscriptionDetailsOfOrgRes, StartPaidSubscriptionReq, SubscriptionDto, UpdateCreditBalanceUsageReq, UpsertOrganizationDiscountRequest } from "../../interfaces";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { apiGet, apiPatch, apiPost } from "../../utilities/api-client/apiRequest";

export async function getMyOrganizationSubscriptionAsync(
    authToken: string,
    includePlan : boolean = false,
    orgId : number | null  | undefined= null,
    signal?: AbortSignal
): Promise<ApiResponse<SubscriptionDto>> {
    let apiUrl: string = `/subscription/getOrgSubscription?includePlan=${includePlan}`;

    if(orgId){
        apiUrl += `&orgId=${orgId}`
    }

    const res = apiGet<ApiResponse<SubscriptionDto>>(
        apiUrl, authToken, signal
    );
    return res;
}

export async function startPaidSubscriptionAsync(
    authToken: string,
    payload :StartPaidSubscriptionReq,
    signal?: AbortSignal
): Promise<ApiResponse<SubscriptionDto>> {
    const apiUrl: string = `/subscription/start-paid-subscription`;

    const res = apiPost<ApiResponse<SubscriptionDto>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}


export async function UpsertOrganizationDiscountAsync(
    authToken: string,
    payload :UpsertOrganizationDiscountRequest,
    signal?: AbortSignal
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `/subscription/UpdateDiscountOfOrg`;

    const res = apiPatch<ApiResponse<boolean>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}

export async function GetSubscriptionDetailsOfOrgAsync(
    authToken: string,
    signal?: AbortSignal
): Promise<ApiResponse<GetSubscriptionDetailsOfOrgRes>> {
    const apiUrl: string = `/subscription/GetSubscriptionDetailsOfOrg`;

    const res = apiGet<ApiResponse<GetSubscriptionDetailsOfOrgRes>>(
        apiUrl, authToken, signal
    );
    return res;
}

export async function GetBillingCalculationByOrgAsync(
    authToken: string,
    orgId? : number,
    signal?: AbortSignal
): Promise<ApiResponse<GetBillingCalculationRes>> {
    let apiUrl: string = `/subscription/GetBillingCalculationByOrg`;

    if(orgId){
        apiUrl += `?orgId=${orgId}`
    }

    const res = apiGet<ApiResponse<GetBillingCalculationRes>>(
        apiUrl,  authToken, signal
    );

    return res;
}

export async function UpdateCreditBalanceUsageAsync(
    authToken: string,
    req : UpdateCreditBalanceUsageReq,
    signal?: AbortSignal
): Promise<ApiResponse<boolean>> {
    let apiUrl: string = `/subscription/UpdateCreditBalanceUsage`;

    const res = apiPatch<ApiResponse<boolean>>(
        apiUrl, req,  authToken, signal
    );

    return res;
}
